import React from 'react'
import EmojiPicker from 'srcReact/components/common2/EmojiPicker'
import styles from './styles.module.scss'
import ReactionButton from './components/ReactionButton'
import Spinner from '../Spinner'

export default function ReactionContainer({
  messageId,
  reactions,
  appendEmoji,
  handleOpenPicker,
  handleReactionClick,
  loggedInUser,
  isProcessing,
  reactionToProcess,
  className,
  reactionButtonClassName,
  isEmojiPicker = true,
  fromMessenger = false
}) {
  return (
    <div className={`${styles.reactionContainer} ${className}`}>
      {isEmojiPicker && (
        <EmojiPicker
          pickerContainerCSS={styles.pickerContainerCSS}
          containerCss={styles.containerCSS}
          emojiButtonCSS={styles.emojiButton}
          iconName='add-reaction'
          iconStyle={styles.dropdownIcon}
          appendEmoji={appendEmoji}
          handleOpenPicker={handleOpenPicker}
        />
      )}
      <div className={styles.reactionPills}>
        {reactions.map((reaction, index) => {
          const loggedInUserReacted = reaction.users.some((u) => u.id_user === loggedInUser.id)
          const reactionBeingProcessed =
            reactionToProcess !== null
              ? reactionToProcess.code === reaction.unified_unicode && reactionToProcess.messageId === messageId
              : false

          return (
            <ReactionButton
              key={`${reaction.id}${index}`}
              isProcessing={isProcessing && reactionBeingProcessed}
              reaction={reaction}
              loggedInUserReacted={loggedInUserReacted}
              onClick={handleReactionClick}
              buttonClassName={reactionButtonClassName}
              fromMessenger={fromMessenger}
            />
          )
        })}
        {isProcessing && reactionToProcess && reactionToProcess.messageId === messageId && (
          <Spinner customCss={styles.loader} />
        )}
      </div>
    </div>
  )
}
